export interface ImageModel {
  id: number;
  filename: string;
  fileType: string;
  fileSize: number;
  linkId: string;
  externalUrl: string;
}
